type AllocationWarning = {
  resourceUuid: string;
  resourceName: string;
  hasDailyAmplitudeWarning: boolean;
  hasDailyVolumeWarning: boolean;
  hasRestPeriodWarning: boolean;
  hasUnavailabilityWarning: boolean;
  unavailabilityLabel: string | null;
  unavailabilityDurationHours: number | null;
};

const allocationWarning: AllocationWarning = {
  resourceUuid: "",
  resourceName: "",
  hasDailyAmplitudeWarning: false,
  hasDailyVolumeWarning: false,
  hasRestPeriodWarning: false,
  hasUnavailabilityWarning: false,
  unavailabilityLabel: null,
  unavailabilityDurationHours: null,
};

type AllocationDraft = {
  resourceUuid: string;
};

type TaskDraft = {
  startDate: string;
  endDate: string;
  allocations: AllocationDraft[];
};

type ExistingTaskCheckRequest = {
  taskUuid: string;
  allocations: AllocationDraft[];
};

type NewTaskCheckRequest = {
  taskDraft: TaskDraft;
};

type CheckAllocationWarningsRequest =
  | ExistingTaskCheckRequest
  | NewTaskCheckRequest;

export type {
  AllocationWarning,
  AllocationDraft,
  TaskDraft,
  CheckAllocationWarningsRequest,
  ExistingTaskCheckRequest,
  NewTaskCheckRequest,
};
export { allocationWarning };
